<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--OneCardFacilityIDExtended-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Facility</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OneCardFacilityExtendedID" [(ngModel)]="report.OneCardFacilityID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OneCardFacilityExtendedList" [ngValue]="o.FacilityID">
									{{ o.FacilityName }}
								</option>
							</select>
						</div>
					</div>

					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select  class="form-control" name="SchoolID" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of SchoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector
								[ShowAll]="true"
								[ShowAllID]="SchoolSelectShowAllID"
								[ShowAllText]="SchoolSelectShowAllText"
								[IsReport]="true"
								[ReportID]="419"
							>
							</caass-schoolselector>
						</div>
					</div>

					<!--IDDepotPQStatusID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Status</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="DepotPQStatusID" [(ngModel)]="report.DepotPQStatusID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of DepotPQStatusList" [ngValue]="o.DepotPQStatusID">
									{{ o.DepotPQStatusDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--GroupBy-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Group By</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="GroupByID" [(ngModel)]="report.GroupByID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of GroupByList" [ngValue]="o.GroupByName">
									{{ o.GroupByName }}
								</option>
							</select>
						</div>
					</div>

					<!--NewPageByGroup-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">New Page By Group</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="NewPageByGroupID" [(ngModel)]="report.NewPageByGroupID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of NewPageByGroupList" [ngValue]="o.NewPageByGroupName">
									{{ o.NewPageByGroupName }}
								</option>
							</select>
						</div>
					</div>

					<!--ImageLogo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ImageLogo" [(ngModel)]="report.ImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ImageLogoList" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--MTACardTypeID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">MTA Card Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="MTACardTypeID" [(ngModel)]="report.MTACardTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of MTACardTypeList" [ngValue]="o.MTACardTypeID">
									{{ o.MTACardTypeDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
